<template>
    <div class="login-modal-content">
      <v-card width="500" class="mx-auto mt-5">
        <div style="text-align:center;padding-top:10px;">
          <h3 v-if="success">Confirm account</h3>
          <h3 v-else-if="confirmed">Reset password</h3>
          <h3 v-else>Forgot password</h3>
        </div>
        <v-card-text>
          <v-alert type="error" v-if="error">{{error}}</v-alert>
          <v-alert type="success" v-if="success">{{success}}</v-alert>
          <v-form ref="form">
            <div style="padding-bottom:20px">
              <vue-phone-number-input 
                v-model="phone_number" 
                label="Phone number"
                default-country-code="ZM"
                required
                @update="getPhoneNumber"
                no-example
              />
            </div>
            <div v-if="success">
              <v-text-field
                label="One Time Password (OTP)"
                v-model="otp"
                outlined
                required     
                dense
              />
            </div>
            <div v-if="confirmed">
              <v-text-field
                label="New Password"
                v-model="password"
                outlined
                type="password"
                required     
                dense
              />
            </div>
            <div v-if="confirmed">
              <v-text-field
                label="Repeat Password"
                v-model="repeat_password"
                outlined
                required     
                type="password"
                dense
              />
            </div>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <div style="text-align:center;padding:10px">
          <v-btn
            :loading="loading"
            color="primary"
            rounded
            dark
            block
            @click="submit"
          >
            Submit
          </v-btn>
        </div>        
      </v-card>  
      <div v-if="success == null && confirmed == null" style="text-align:center">
        <br />
        <p style="padding-bottom:0px">
          You will receive a<b> One Time Password</b> for logging in.
        </p>
        <p style="padding-top:0px"> 
          Once logged in, please<b> Change your Password</b>
        </p>
      </div>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  import axios from "axios";

  const URL_GENERATE_OTP = "http://139.59.131.242:4000/user/generateOTP";
  const URL_VALIDATE_OTP = "http://139.59.131.242:4000/user/validateOTP";
  const URL_RESET_OTP = "http://139.59.131.242:4000/user/changePasswordOTP";
  
  export default {
    name: 'Login',
    data: () => ({
      phone_number: '',
      email_address: '',
      loading: false,
      error: null,
      success: null,
      data: null,
      confirmed: null,
      password: '',
      repeat_password: '',
      otp: ''
    }),
    methods: {
      submit() {
        if (this.success){
          this.loading = true;

          if ((this.phone_number.length == 0 && this.otp.length == 0)){
            this.error = 'Please enter both your Phone number and your OTP!';
          }else{
            const user = {
              phone_number: this.user.data.phone_number,
              otp: this.otp
            }
            console.log(user);
            axios
            .post(URL_VALIDATE_OTP, user )
            .then(response => {
              console.log(response)
              if (response.status == 200){
                this.confirmed = response.data.message;
                this.error = null;
                this.success = null;
                this.loading = false;
              }
            })
            .catch(error => {
              console.log(error);
              this.error = 'Request unsuccessful!';
              this.loading = false;
            }); 
          }
        }else if (this.confirmed){
          this.loading = true;

          if ((this.phone_number.length == 0 && this.otp.length == 0)){
            this.error = 'Please enter both your Phone number and your OTP!';
          }else if (this.password != this.repeat_password){
            this.error = 'The two passwords did not match! Please try again.';
          }else{
            const user = {
              phone_number: this.user.data.phone_number,
              otp: this.otp,
              password: this.password
            }
            
            axios
            .post(URL_RESET_OTP, user )
            .then(response => {
              console.log(response)
              if (response.status == 200){
                this.confirmed = response.data.message;
                this.error = null;
                this.success = null;
                this.loading = false;
                this.$router.push('/login');
              }
            })
            .catch(error => {
              console.log(error);
              this.error = 'Request unsuccessful!';
              this.loading = false;
            }); 
          }
        }else{
          if (this.phone_number.length == 0){
            this.error = 'Please enter both your Phone number and your OTP!';
          }else{
            this.loading = true;

            const user = {
              phone_number: this.user.data.phone_number,
            }
            
            axios
            .post(URL_GENERATE_OTP, user )
            .then(response => {
              console.log(response);
              if (response.status == 201){
                this.success = response.data.message;
                this.error = null;
                this.loading = false;
              }
            })
            .catch(error => {
              console.log(error);
              this.error = 'Request unsuccessful!';
              this.loading = false;
            }); 
          }
        }
      },
      getPhoneNumber(payload){
        this.user.data.phone_number = payload.formattedNumber;
      }
    },
    computed: {
      ...mapGetters({
        user: "user"
      })
    }
  }
</script>